import { Burger } from "./../Burger/Burger";
import { DataContext } from "./../../context/DataContext";
import { getEndpoint } from "../../utils/getDataFromWordpress";
import { getLocaleUrl } from "../../utils/getLocaleUrl";
import { Link } from "../Link/link";
import { useFetch } from "usehooks-ts";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect } from "react";

import "./header.scss";

export const Header = React.forwardRef((props, fullPageRef) => {
	const { i18n } = useTranslation();
	const { wp } = getEndpoint(i18n["language"]);
	const location = useLocation();
	const [open, setOpen] = React.useState(false);
	const { languages } = React.useContext(DataContext);
	const { data, error } = useFetch(`${wp}/navigation/header-menu`);
	const navigate = useNavigate();

	useEffect(() => {
		if (!languages?.["available"]?.["length"]) {
			return;
		}

		let to = location["pathname"];
		to = getLocaleUrl(to, i18n["language"], languages["available"]);

		if (to !== location["pathname"]) {
			navigate(to);
		}
	}, [i18n["language"], languages, location]);

	return (
		<div
			className={[`header`, `header--${location.pathname === "/" ? `is-fixed` : `is-sticky`}`].join(
				` `
			)}>
			<div className={`header-wrapper`}>
				<div
					className={[
						`header-navigation`,
						`header-navigation--${open ? `is-open` : `not-open`}`,
					].join(` `)}>
					{!error &&
						data?.map((i, index) => (
							<Link
								key={index}
								onClick={() => setOpen(false)}
								className={`_base header-navigation-item`}
								to={i.url}>
								{i.title}
							</Link>
						))}
					{!!languages?.["available"]?.["length"] &&
						languages["available"].map(
							(lang) =>
								lang !== i18n["language"] && (
									<Fragment key={lang}>
										<Link
											onClick={(event) => {
												event.preventDefault();
												i18n.changeLanguage(lang);
												setOpen(false);
											}}
											className={`_base header-navigation-item`}
											to={`${lang}`}
											style={{ textTransform: "capitalize" }}>
											{lang}
										</Link>
									</Fragment>
								)
						)}
				</div>
				<Burger className={`header-burger`} onClick={() => setOpen(!open)} open={open} />
				<div className={`header-title`}>
					{props.match ? (
						<span onClick={() => fullPageRef.current.fullpageApi.moveTo(1)} className={`_base`}>
							oSuonoMio
						</span>
					) : (
						<Link
							onClick={() => {
								setOpen(false);
							}}
							to={`/`}>
							oSuonoMio
						</Link>
					)}
				</div>
			</div>
		</div>
	);
});
